import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";
import { initialState } from "../initialState";

const login: EvokeAction<AppState, AppActions> = async (
  store,
  credentials: { username: string; password: string }
) => {
  const auth = await api.post("auth/login", undefined, credentials);
  localStorage.setItem("authStoreCode",auth.store_code);
  api.setAuthToken(auth.token as string);
   await store.actions.getMe();
};

const logout: EvokeAction<AppState, AppActions> = async store => {
  await store.update(state => {
    return initialState;
  });
};

const getMe: EvokeAction<AppState, AppActions> = async store => {
  try {
    const me = await api.get("auth/me");
    await store.update(state => {
      if (!state.auth) {
        state.auth = {};
      }
      state.auth.user = me;
    });
  } catch (error) {
    // TODO
    await store.update(state => {
      if (!state.auth) {
        state.auth = {};
      }
      state.auth.user = undefined;
    });
  }
};

export const authActions = {
  login,
  getMe,
  logout
};
